// frontend_react/src/components/home/EventsCard.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCalendarEvents } from "../../services/calendarApi";
import logger from '../../utils/logger';
import calendarIcon from '../../assets/calendar.svg';
import { useAdminScope } from "../../context/AdminScopeContext";

export default function EventsCard() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const {
    selectedCompanyUuid,
    selectedActivityUuid,
  } = useAdminScope();

  useEffect(() => {
    const fetchUpcomingEvents = async () => {
      try {
        const res = await getCalendarEvents({
          companyUuid: selectedCompanyUuid,
          activityUuid: selectedActivityUuid,
        });
        const arr = Array.isArray(res.data) ? res.data : (res.data.events ?? []);
        
        const now = new Date();
        const upcoming = arr
          .filter(ev => new Date(ev.start_timestamp) >= now)
          .sort((a, b) => new Date(a.start_timestamp) - new Date(b.start_timestamp))
          .slice(0, 3);

        setEvents(upcoming);
      } catch (err) {
        logger.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUpcomingEvents();
  }, [
    selectedCompanyUuid,
    selectedActivityUuid,
  ]);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
  };

  return (
    <div className="card flex-col justify-between gap-sm h-full">
      <div className="flex-col gap-sm">
        <div className="text_with_icon m-md no-margin">
          <img src={calendarIcon} className="white_svg" alt="Calendar" />
          <span className="font-size-label bold">Événements à venir</span>
        </div>
        
        <div className="flex-col gap-sm" style={{ marginTop: '10px' }}>
          {loading ? (
            <p className="muted_text font-size-body">Chargement...</p>
          ) : events.length > 0 ? (
            events.map((ev) => (
              <div 
                key={ev.uuid} 
                className="event-pill dark-card p-sm flex justify-between items-center cursor-pointer"
                onClick={() => navigate(`/event/${ev.uuid}/register`)}
              >
                <p className="no-margin bold">{ev.title}</p>
                <p className="muted_text no-margin font-size-body">le {formatDate(ev.start_timestamp)}</p>
              </div>
            ))
          ) : (
            <p className="muted_text font-size-body">Aucun événement prévu.</p>
          )}
        </div>
      </div>
      
      <button 
        className="button-action" 
        style={{ marginTop: 'auto' }}
        onClick={() => navigate('/events')}
      >
        Voir plus
      </button>
    </div>
  );
}